import React from 'react';
import { Text } from 'react-native';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { create } from '../../menu';
const Label = create(_ref => {
  let {
    children,
    style
  } = _ref;
  return /*#__PURE__*/React.createElement(DropdownMenu.Label, null, /*#__PURE__*/React.createElement(Text, {
    style: style
  }, children));
}, 'Label');
export { Label };
//# sourceMappingURL=label.js.map